import { PIPELINE_MAP } from './pipelineRegistry'
import { DOMAIN_REGISTRY, type Domain } from './domainRegistry'

/** Formats a raw enum value for display: first letter uppercase, rest lowercase, underscores → spaces */
export function formatEnumLabel(raw: string): string {
  return raw
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace(/^\w/, c => c.toUpperCase())
}

/** Gets display label for a pipeline stage code, falls back to formatEnumLabel */
export function formatStageLabel(code: string): string {
  return PIPELINE_MAP[code as keyof typeof PIPELINE_MAP]?.label ?? formatEnumLabel(code)
}

/** Gets display label for a domain, falls back to formatEnumLabel */
export function formatDomainLabel(domain: string): string {
  return DOMAIN_REGISTRY[domain as Domain]?.label ?? formatEnumLabel(domain)
}

/** Gets icon for a domain */
export function getDomainIcon(domain: string): string {
  return DOMAIN_REGISTRY[domain as Domain]?.icon ?? ''
}
